import { css } from "react-emotion";
import { flatWrapper, flex } from "appStyles";

export const container = css`
  ${flatWrapper};
`;

export const borderContainer = css`
  box-shadow: 6px 7px 5px -2px #c2baba;
  border: 1px solid #c2baba;
  width: 850px;
  height: 450px;
  padding: 1em;
  background: white;
  overflow-y: auto;
`;

export const borderContainerWebsite = css`
  box-shadow: 6px 7px 5px -2px #c2baba;
  border: 1px solid #c2baba;
  padding: 1em;
  background: white;
`;

export const header = css`
  position: relative;
  font-size: 2rem;
  display: flex;
  align-items: center;

  img {
    width: 3rem;
    cursor: pointer;
    margin-right: 2rem;
    cursor: pointer;
    transition: 0.1s;

    &:hover {
      transform: scale(1.2);
      transition: 0.3s;
    }
  }
`;

export const pageTitle = css`
  width: 30rem;
`;
